// @flow

import * as React from "react";

import TextInput from "../Input/TextInput";
import type { InputType } from "../Input/TextInput";

import styles from "./PasswordInput.scss";

type PasswordInputProps = {
  label: string,
  placeholder: string,
  input: InputType,
  tabIndex: ?string
};

type PasswordInputState = {
  isPasswordHidden: boolean
};

class PasswordInput extends React.Component<PasswordInputProps, PasswordInputState> {
  static defaultProps = {
    placeholder: "",
    label: "",
    input: null,
    tabIndex: null
  };

  state = {
    isPasswordHidden: true
  };

  togglePasswordShow = () =>
    this.setState(currentState => ({
      isPasswordHidden: !currentState.isPasswordHidden
    }));

  renderPasswordRevealButton = () => {
    const { isPasswordHidden } = this.state;
    const { tabIndex } = this.props;

    return (
      <button
        type="button"
        className={styles.passwordRevealButton}
        onClick={this.togglePasswordShow}
        data-testid="revealPassword"
        tabIndex={tabIndex ? parseInt(tabIndex, 10) + 1 : undefined}
      >
        {isPasswordHidden ? <i className="icon-eye" /> : <i className="icon-eye-off" />}
      </button>
    );
  };

  render() {
    const { label, placeholder, input, tabIndex, ...restProps } = this.props;
    const { isPasswordHidden } = this.state;
    return (
      <TextInput
        additionalClasses={styles.passwordInput}
        autoComplete="on"
        data-testid={`passwordInput:${input.name}`}
        input={input}
        label={label}
        placeholder={placeholder}
        sideSymbol={this.renderPasswordRevealButton}
        type={isPasswordHidden ? "password" : "text"}
        tabIndex={tabIndex || undefined}
        {...restProps}
      />
    );
  }
}

export default PasswordInput;
